export default {
  /**
   * Không bắt buộc
   */
  NotRequired: 0,

  /**
   * Bắt buộc
   */
  Required: 1
}
